import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({
  scale,
  verticalOffset = 0,
  gradientStop1 = '#53533F',
  gradientStop2 = '#010101',
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`
  const transformOrigin = '28.44 9.52'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <g opacity="0.9">
        <path
          opacity="0.9"
          d="M15.4698 17.2401C8.41982 16.9101 4.03981 8.11003 6.10981 3.53003C7.42981 0.610033 15.5398 2.48001 16.6798 2.76001C22.5698 4.19001 24.9898 5.95006 24.9398 8.93006C24.8798 11.9001 22.5198 17.5701 15.4698 17.2401Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path
          opacity="0.9"
          d="M41.3998 17.2401C34.3498 17.5701 31.9898 11.9001 31.9298 8.93006C31.8698 5.96006 34.2998 4.20001 40.1898 2.76001C41.3298 2.48001 49.4398 0.610033 50.7598 3.53003C52.8298 8.11003 48.4398 16.9101 41.3998 17.2401Z"
          fill={`url(#${randomGradientId2})`}
        />
      </g>
      <path
        d="M31.7 4.41001C30.59 4.96001 28.9999 5.01 28.5099 5.02C28.5099 5.02 28.4799 5.02 28.4299 5.02C28.3799 5.02 28.3499 5.02 28.3499 5.02C27.8599 5.02 26.2599 4.97001 25.1599 4.41001C23.8399 3.75001 15.2499 -1.30998 0.939941 0.670024C0.939941 0.670024 2.03994 9.42007 7.43994 15.0901C10.8599 18.6801 15.9099 19.37 19.7399 18.12C21.9499 17.4 23.64 16.0101 24.67 14.2101C27.44 9.38006 26.2999 8.72006 28.4399 8.71006C30.5799 8.73006 29.4399 9.38006 32.2099 14.2101C33.2399 16.0001 34.93 17.39 37.14 18.12C40.97 19.37 46.0199 18.6901 49.4399 15.0901C54.8299 9.42007 55.9399 0.670024 55.9399 0.670024C41.6099 -1.30998 33.02 3.75001 31.7 4.41001ZM15.4699 17.29C8.41994 16.96 4.03992 8.16006 6.10992 3.58006C7.42992 0.660058 15.5399 2.53004 16.6799 2.81004C22.5699 4.24004 24.9899 6.00008 24.9399 8.98008C24.8799 11.9501 22.5099 17.62 15.4699 17.29ZM41.39 17.29C34.34 17.62 31.98 11.9501 31.92 8.98008C31.86 6.01008 34.2899 4.25004 40.1799 2.81004C41.3199 2.53004 49.4299 0.660058 50.7499 3.58006C52.8199 8.16006 48.44 16.96 41.39 17.29Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="15.269"
          y1="2.98033"
          x2="15.269"
          y2="14.4321"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="41.5999"
          y1="2.98033"
          x2="41.5999"
          y2="14.4321"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
      </defs>
    </g>
  )
}
